import styled from 'styled-components';

export const Wrapper = styled.div``;
export const TermCondition = styled.div`
  background: ${({ theme }) => theme.palette.boxBackgroundDark};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => `${theme.spacing.x3} ${theme.spacing.x4}`};
  direction: ltr;
`;
export const TermConditionTitle = styled.div`
  // font-size:
  margin-bottom: ${({ theme }) => theme.spacing.x4};
  color: ${({ theme }) => theme.palette.primary46};
`;

export const TermConditionUl = styled.ul`
  list-style-position: inside;
  text-align: justify;
`;
export const TermConditionLi = styled.li`
  color: rgba(31, 44, 81, 0.7);
`;
